export const PridobivanjeStatusVloge = {
  methods: {
    PridobiStatusVloge (prenosniParam) {
      if (typeof prenosniParam.prenesenIzbranId !== 'undefined' && prenosniParam.prenesenIzbranId !== '' &&
        prenosniParam.prenesenIzbranId !== null) {
        let param = ['idPrikljucek=' + prenosniParam.prenesenIzbranId]
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/statusVloge?',
          param,
          prenosniParam,
          'SetStatusVloge',
          'ErrStatusVloge')
      }
    },
    SetStatusVloge (podatki, prenosniParam) {
      let seznam = podatki.data
      let vmesnik = prenosniParam.vmesnik
      let nalaganje = false
      vmesnik.PridobiStatusVlogePrenosni(prenosniParam, seznam, nalaganje)
    },
    ErrStatusVloge (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/StatusVloge/PridobivanjeStatusVloge.js